import { Link } from "react-router-dom";
import Header from "../landing/Header";
import Footer from "../landing/Footer";
import CookieBanner from "../landing/CookieBanner";
import useSeo from "../landing/useSeo";
import { DOCS, REQUISITES, SITE } from "../landing/siteConfig";
import "../landing/landing.css";

const Privacy = () => {
    useSeo({
        title: `Политика обработки персональных данных — ${SITE.brand}`,
        description: `Политика обработки персональных данных сайта ${SITE.domain}. Оператор — ${REQUISITES.shortName}. Цели, основания, сроки обработки и права субъекта.`,
        path: "/privacy",
    });

    return (
        <div className="lp">
            <Header />
            <main className="doc">
                <div className="wrap wrap--narrow">
                    <nav className="crumbs" aria-label="Хлебные крошки">
                        <Link to="/">Главная</Link>
                        <span>/</span>
                        <span>Политика обработки персональных данных</span>
                    </nav>

                    <h1 className="doc__title">Политика в отношении обработки персональных данных</h1>
                    <p className="doc__meta">
                        Редакция от {DOCS.updated} · сайт {SITE.domain}
                    </p>

                    <h2>1. Общие положения</h2>
                    <p>
                        1.1. Настоящая Политика определяет порядок обработки персональных
                        данных и меры по обеспечению их безопасности в соответствии с
                        Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и
                        принята во исполнение требований части 2 статьи 18.1 указанного закона.
                    </p>
                    <p>
                        1.2. Оператором персональных данных является {REQUISITES.legalName}{" "}
                        (далее — Оператор), ОГРНИП {REQUISITES.ogrnip}, ИНН {REQUISITES.inn},
                        адрес: {REQUISITES.address}.
                    </p>
                    <p>
                        1.3. Политика распространяется на все персональные данные, которые
                        Оператор получает от посетителей и пользователей сайта {SITE.domain}{" "}
                        (далее — Сайт).
                    </p>
                    <p>
                        1.4. Действующая редакция Политики размещена в свободном доступе по
                        адресу <Link to="/privacy">{SITE.domain}/privacy</Link>.
                    </p>

                    <h2>2. Основные понятия</h2>
                    <p>
                        <b>Персональные данные</b> — любая информация, относящаяся к прямо или
                        косвенно определённому или определяемому физическому лицу (субъекту
                        персональных данных).
                    </p>
                    <p>
                        <b>Обработка персональных данных</b> — любое действие или совокупность
                        действий с персональными данными, совершаемых с использованием средств
                        автоматизации или без них: сбор, запись, систематизация, накопление,
                        хранение, уточнение, извлечение, использование, передача, блокирование,
                        удаление, уничтожение.
                    </p>
                    <p>
                        <b>Пользователь</b> — посетитель Сайта, зарегистрировавший личный
                        кабинет или направивший обращение через контактные данные Оператора.
                    </p>

                    <h2>3. Какие данные обрабатываются</h2>
                    <p>
                        3.1. Оператор обрабатывает персональные данные, которые Пользователь
                        сообщает добровольно при регистрации личного кабинета на Сайте:
                    </p>
                    <ul>
                        <li>фамилия, имя (в объёме, указанном Пользователем);</li>
                        <li>адрес электронной почты, используемый в качестве логина;</li>
                        <li>пароль (хранится в зашифрованном виде);</li>
                        <li>данные о кампаниях, тематиках, регионах и балансе личного кабинета.</li>
                    </ul>
                    <p>
                        3.2. Дополнительно средствами Сайта автоматически собираются
                        обезличенные данные о посещении: IP-адрес, сведения о браузере и
                        операционной системе, дата и время обращения, адрес страницы-источника
                        перехода, данные файлов cookie.
                    </p>
                    <p>
                        3.3. Оператор не обрабатывает специальные категории персональных данных
                        (о расовой, национальной принадлежности, политических взглядах,
                        религиозных убеждениях, состоянии здоровья, интимной жизни) и
                        биометрические персональные данные.
                    </p>

                    <h2>4. Цели обработки</h2>
                    <p>4.1. Персональные данные обрабатываются исключительно в следующих целях:</p>
                    <ul>
                        <li>регистрация и аутентификация Пользователя в личном кабинете;</li>
                        <li>предоставление доступа к сервису покупки лидов и его функциям;</li>
                        <li>связь с Пользователем по вопросам работы кабинета и кампаний;</li>
                        <li>заключение и исполнение договора на приобретение лидов;</li>
                        <li>улучшение работы Сайта на основании обезличенной статистики посещений.</li>
                    </ul>
                    <p>
                        4.2. Оператор не использует персональные данные для рассылок
                        рекламного характера, не связанных с использованием сервиса, без
                        отдельного согласия Пользователя.
                    </p>

                    <h2>5. Правовые основания обработки</h2>
                    <p>
                        5.1. Основанием обработки является согласие Пользователя на обработку
                        персональных данных, которое он даёт при регистрации личного кабинета.
                        Текст согласия размещён по адресу <Link to="/consent">/consent</Link>.
                    </p>
                    <p>
                        5.2. Также основаниями являются Конституция Российской Федерации,
                        Гражданский кодекс Российской Федерации, Федеральный закон № 152-ФЗ «О
                        персональных данных» и заключаемые с Пользователем договоры.
                    </p>

                    <h2>6. Порядок и сроки обработки</h2>
                    <p>
                        6.1. Обработка осуществляется смешанным способом: с использованием
                        средств автоматизации и без их использования.
                    </p>
                    <p>
                        6.2. Персональные данные хранятся в форме, позволяющей определить
                        субъекта, не дольше, чем этого требуют цели обработки, но не более 3
                        (трёх) лет с момента прекращения использования личного кабинета, если
                        иной срок не установлен законом или договором.
                    </p>
                    <p>
                        6.3. Обработка прекращается, а данные уничтожаются в случаях:
                        достижения целей обработки, отзыва согласия Пользователем, удаления
                        аккаунта, выявления неправомерной обработки, ликвидации Оператора.
                    </p>
                    <p>
                        6.4. Базы данных, содержащие персональные данные граждан Российской
                        Федерации, находятся на территории Российской Федерации в соответствии
                        с частью 5 статьи 18 Федерального закона № 152-ФЗ.
                    </p>

                    <h2>7. Передача персональных данных</h2>
                    <p>
                        7.1. Оператор не продаёт и не передаёт персональные данные
                        Пользователей третьим лицам, за исключением случаев, прямо
                        предусмотренных законодательством Российской Федерации, а также
                        случаев привлечения подрядчиков (хостинг-провайдер, оператор связи,
                        сервис электронной почты), действующих по поручению Оператора и
                        обязанных соблюдать конфиденциальность.
                    </p>
                    <p>7.2. Трансграничная передача персональных данных Оператором не осуществляется.</p>
                    <p>
                        7.3. Обращаем внимание: сведения о клиентах, содержащиеся в
                        передаваемых покупателям лидах, обрабатываются на основании отдельных
                        согласий этих лиц и в рамках отдельных договорных отношений; настоящая
                        Политика регулирует только данные пользователей личного кабинета.
                    </p>

                    <h2>8. Защита персональных данных</h2>
                    <p>
                        8.1. Оператор принимает правовые, организационные и технические меры,
                        необходимые для защиты персональных данных от неправомерного доступа,
                        уничтожения, изменения, блокирования, копирования и распространения, в
                        том числе: назначение ответственного за организацию обработки,
                        ограничение круга лиц с доступом к данным, использование защищённого
                        соединения (HTTPS), хранение паролей в зашифрованном виде, резервное
                        копирование и контроль доступа к местам хранения.
                    </p>
                    <p>
                        8.2. В случае выявления неправомерной обработки Оператор устраняет
                        нарушение в сроки, установленные Федеральным законом № 152-ФЗ.
                    </p>

                    <h2>9. Файлы cookie и метрические программы</h2>
                    <p>
                        9.1. Сайт использует файлы cookie — небольшие текстовые файлы,
                        сохраняемые браузером, которые необходимы для корректной работы Сайта,
                        включая поддержание сессии авторизованного пользователя.
                    </p>
                    <p>
                        9.2. Пользователь вправе в любой момент запретить сохранение cookie в
                        настройках своего браузера либо удалить сохранённые файлы. Отключение
                        cookie может повлиять на работоспособность личного кабинета.
                    </p>
                    <p>
                        9.3. При использовании на Сайте систем веб-аналитики обработка
                        осуществляется в обезличенном виде для сбора статистики посещаемости.
                    </p>

                    <h2>10. Права субъекта персональных данных</h2>
                    <p>10.1. Пользователь вправе:</p>
                    <ul>
                        <li>
                            получать сведения об обработке своих персональных данных,
                            предусмотренные частью 7 статьи 14 Федерального закона № 152-ФЗ;
                        </li>
                        <li>
                            требовать уточнения, блокирования или уничтожения данных, если они
                            неполны, устарели, неточны, незаконно получены или не являются
                            необходимыми для заявленной цели обработки;
                        </li>
                        <li>отозвать согласие на обработку персональных данных и удалить аккаунт;</li>
                        <li>обжаловать действия Оператора в Роскомнадзоре или в судебном порядке.</li>
                    </ul>
                    <p>
                        10.2. Для реализации своих прав, включая отзыв согласия, Пользователю
                        достаточно направить обращение на адрес{" "}
                        <a href={`mailto:${SITE.email}`}>{SITE.email}</a> с указанием фамилии,
                        имени и контактных данных, которые были переданы через Сайт. Оператор
                        рассматривает обращение в течение 10 (десяти) рабочих дней.
                    </p>
                    <p>
                        10.3. Отзыв согласия влечёт прекращение обработки и уничтожение
                        персональных данных в срок, не превышающий 30 (тридцати) дней с даты
                        поступления обращения, за исключением сведений, которые Оператор обязан
                        хранить в силу закона.
                    </p>

                    <h2>11. Заключительные положения</h2>
                    <p>
                        11.1. Оператор вправе вносить изменения в настоящую Политику. Новая
                        редакция вступает в силу с момента её размещения на Сайте, если иное не
                        предусмотрено новой редакцией.
                    </p>
                    <p>
                        11.2. Все предложения и вопросы по Политике направляются на{" "}
                        <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                        {SITE.phone && (
                            <> либо по телефону <a href={`tel:${SITE.phoneLink}`}>{SITE.phone}</a></>
                        )}
                        .
                    </p>

                    <h2>12. Реквизиты Оператора</h2>
                    <dl className="doc__req">
                        <div>
                            <dt>Наименование</dt>
                            <dd>{REQUISITES.legalName}</dd>
                        </div>
                        <div>
                            <dt>ОГРНИП</dt>
                            <dd>{REQUISITES.ogrnip}</dd>
                        </div>
                        <div>
                            <dt>ИНН</dt>
                            <dd>{REQUISITES.inn}</dd>
                        </div>
                        <div>
                            <dt>Адрес</dt>
                            <dd>{REQUISITES.address}</dd>
                        </div>
                        {SITE.phone && (
                            <div>
                                <dt>Телефон</dt>
                                <dd>
                                    <a href={`tel:${SITE.phoneLink}`}>{SITE.phone}</a>
                                </dd>
                            </div>
                        )}
                        <div>
                            <dt>Электронная почта</dt>
                            <dd>
                                <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                            </dd>
                        </div>
                    </dl>

                    <p className="doc__back">
                        <Link to="/" className="btn btn--sm">
                            Вернуться на главную
                        </Link>
                    </p>
                </div>
            </main>
            <Footer />
            <CookieBanner />
        </div>
    );
};

export default Privacy;
